/**
 * @generated SignedSource<<6119863ea6735a39442a8e9f18f186b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PersonRequest$data = {
  readonly feedback: {
    readonly id: string;
    readonly isAnonymous: boolean;
  };
  readonly feedbackRecord: {
    readonly contents: any | null;
    readonly id: string;
  } | null;
  readonly id: string;
  readonly user: {
    readonly department: string | null;
    readonly email: string;
    readonly firstName: string;
    readonly fullName: string;
    readonly id: string;
    readonly image: string;
    readonly isGuest: boolean;
    readonly lastName: string;
    readonly title: string | null;
  };
  readonly " $fragmentType": "PersonRequest";
};
export type PersonRequest$key = {
  readonly " $data"?: PersonRequest$data;
  readonly " $fragmentSpreads": FragmentRefs<"PersonRequest">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PersonRequest",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FeedbackNode",
      "kind": "LinkedField",
      "name": "feedback",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAnonymous",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeedbackRecordNode",
      "kind": "LinkedField",
      "name": "feedbackRecord",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contents",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "image",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "department",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FeedbackRequestNode",
  "abstractKey": null
};
})();

(node as any).hash = "2504c90ef7a9e8b733abb5110b1f69d8";

export default node;
